import { Button, DateInput, Modal } from "components"
import { Fragment, useState } from "react"
import { useApi, useToggle } from "utils"
import { SelectTypeSchedule } from "../../hooks"
import { IoSendSharp } from "react-icons/io5"
import moment from "moment"
import toast from "react-hot-toast"
import { Detail } from "./Detail"

export function CreateApproval({
    data,
    refetch
}: {
    data: SelectTypeSchedule
    refetch: () => void
}) {
    const { isActive, toggle } = useToggle(false)

    return (
        <Fragment>
            <Button
                type="button"
                color="ghost"
                permission={"CT07"}
                onClick={toggle}
                disabled={Boolean(Number(data?.approve_status) === 3 || Number(data?.approve_status) === 4)}
            >
                <IoSendSharp />
            </Button>
            {isActive && <ModalSection toggle={toggle} shift_schedule_id={data.value} refetch={refetch} />}
        </Fragment>
    )
}


function ModalSection(props: {
  toggle: () => void,
  shift_schedule_id: string,
  refetch: () => void
}): JSX.Element {
  const api = useApi()
  const [date, setDate] = useState<string>(moment().format("YYYY-MM-DD"))


  const onSubmit = (date: string | undefined, status: number) => {
    return new Promise<void>((resolve) => {
      toast.promise(
        api.post(`/employee/approve_schedule?shift_schedule_id=${props.shift_schedule_id}&approve_date=${date}&approve_status=${status}`),
        {
          loading: "Loading...",
          success: (res) => res.data.message,
          error: (err) => {
            console.log(err);
            
            return err.response.data.message ?? err.response.message
          }
        }
      ).then(() => {
        props.toggle()
        props?.refetch && props.refetch()
      }).catch(() => { }).finally(resolve)
    })
  }

  return (
    <Modal
      isdarktitle
      isOpen
      title="APPROVE SHIFT SCHEDULE"
      closeModal={props.toggle}
    >

      <Modal.Body>
        <Detail idSchedule={props.shift_schedule_id}/>
      </Modal.Body>

      <Modal.Footer className="flex md:flex-row flex-col justify-between md:items-end gap-3">
        <DateInput
          placeholderText="Select Date"
          selected={moment(date).toDate()}
          className="w-full"
          label="APPROVAL DATE"
          onChange={(date) => {
            const selectDate = moment(date).format("YYYY-MM-DD")
            setDate(selectDate)
          }}
        />

        <section className="flex gap-3">
          <Button onClick={props.toggle}>CANCEL</Button>
          <Button color="error" onClick={() => onSubmit(date, 3)}>REJECT</Button>
          <Button color="primary" onClick={() => onSubmit(date, 4)} >APPROVE</Button>
        </section>
      </Modal.Footer>

    </Modal>
  )
}